/* Hook encargado de hacer la consulta a la base y 
traer  el contenido de los body de los vehiculos

Autor: Benjamín León
Fecha: 2024-08-25
*/
import { useState } from 'react'

import VehicleBody from '../interfaces/VehicleBody.ts'
import { customFetch } from '../utils/customFetch.ts'

import { makeUrlBodies } from './connectionData.tsx'

const useBodiesFetcher = () => {
  const [errorBodies, setErrorBodies] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const fetchBodiesData = async () => {
    setLoading(true)

    try {
      const apiUrl = makeUrlBodies()
      const data = await customFetch<VehicleBody[]>(apiUrl)
      setErrorBodies(null)

      return data
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorBodies(err)
      } else {
        setErrorBodies(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorBodies, loading, fetchBodiesData }
}

export default useBodiesFetcher
